import React from 'react';
import _get from 'lodash/get';
import dayjs from 'dayjs';
import { StringColumn, BooleanColumn, CustomColumn } from 'baseui/data-table';
import { EMPTY_STRING } from 'commons-ui';

export const COL_NAMES = {
	category: 'category',
	description: 'description',
	isActive: 'isActive',
	createdBy: 'createdBy',
	createdAt: 'createdAt',
	updatedBy: 'updatedBy',
	updatedAt: 'updatedAt'
};

export const columnConfigs = [
	StringColumn({
		title: 'Category',
		mapDataToValue: (data: any) => data[COL_NAMES.category] || EMPTY_STRING
	}),
	CustomColumn({
		title: 'Description',
		maxWidth: 600,
		mapDataToValue: (data: any) => JSON.stringify(data[COL_NAMES.description] || EMPTY_STRING),
		renderCell: (params: any) => {
			const { value } = params;
			let descriptionCompress = '';
			if (value.length > 60) {
				descriptionCompress = `${value.substr(0, 60)}...`;
			} else {
				descriptionCompress = value;
			}

			return <div title={value}>{descriptionCompress}</div>;
		}
	}),
	BooleanColumn({
		title: 'Is Active',
		mapDataToValue: (data: any) => data[COL_NAMES.isActive] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Created By',
		minWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.createdBy] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Created At',
		mapDataToValue: (data: any) => {
			return _get(data, COL_NAMES.createdAt)
				? dayjs(new Date(_get(data, COL_NAMES.createdAt))).format('DD-MM-YYYY hh:mm A')
				: 'NA';
		}
	}),
	StringColumn({
		title: 'Updated By',
		minWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.updatedBy] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Updated At',
		mapDataToValue: (data: any) => {
			return _get(data, COL_NAMES.updatedAt)
				? dayjs(new Date(_get(data, COL_NAMES.updatedAt))).format('DD-MM-YYYY hh:mm A')
				: 'NA';
		}
	})
];
